import { Component, OnInit, Input } from '@angular/core';
import { EditorService } from '../../editor.service';
import { EditOptionService } from '../../editOptions.service';
import { Book } from '../../../../shared/models/book';
import { BookData } from '../../../../shared/models/bookData';
import { Page } from '../../../../shared/models/page';
@Component({
  selector: 'app-pagebackgroundcolor',
  templateUrl: './pagebackgroundcolor.component.html',
  styleUrls: ['./pagebackgroundcolor.component.css']
})
export class PagebackgroundcolorComponent implements OnInit {
  @Input() data: any;
  public bookObj: Book;
  public bookDataObj: BookData;
  public pageObj: Page;

  constructor(private editorService: EditorService, private editorOptionsService: EditOptionService) { }

  ngOnInit() {
    this.bookObj = this.data.popupProps.curComp.bookObj;
    this.bookDataObj = this.data.popupProps.curComp.bookDataObj;
    this.pageObj = this.data.popupProps.curComp.pageObj;
  }

  changepageColor(clr) {
    let layer = this.editorService.getIframeReference();
    let obj = {
      'type': 'color',
      'bgcolor': clr
    }
    layer.setPageBackGroundStyle(obj);
    if (this.bookObj.bookCategory == 1) {
      this.pageObj.isCustomBg = true;
      this.bookDataObj[this.pageObj.id + ""] = this.pageObj;
      this.editorOptionsService.updateBookDataObj(this.bookDataObj);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/pagebackgroundcolor/pagebackgroundcolor.component.ts